<script type="text/javascript">
    import {http} from '../../../system/http.js';

    export default {

        props: ['chooseFromLogin'],

        data: function () {

            return {
                clients: [],
                settingsLogin: null,
                slug: null,
                pin: null,
                phone_email: null,
                submitted: null,
                loading: false,
                permalink: permalink,
            }

        },

        mounted: function () {
            this.$event_bus.$on('LoadUserData', (data) => {
                this.settingsLogin = data.settings_login;
            });

            this.$event_bus.$on('chooseLoginUser2', (data) => {
                this.clients = data.clients;
                this.pin = data.pin;
                this.phone_email = data.phone_email;
                this.submitted = data.submitted;
            });

        },

        methods: {

            clientClicked(client) {
                this.loading = true;
                const dataFrm = new FormData($('#choose-user-frm')[0]);

                if (client == 'new') {
                    dataFrm.append('new_client', 1);
                } else {
                    dataFrm.append('client', client.id);
                }

                http.post('/book/' + this.permalink + '/login', dataFrm)
                    .then(({data}) => {
                        if (window.location.href.search('login') != -1) {
                            this.$event_bus.$emit('LoggedIn');
                            this.$router.push('/book/' + this.permalink );
                        }else{
                            location.reload();
                        }
                    })
                    .catch(({error, errorBag}) => {
                        this.loading = false;
                    });
            },

            goBackToChoose() {
                this.$event_bus.$emit('goBackToChoose');
            }

        },
    };


</script>


<template id="choose-login-user">

    <div class="row">

        <div class="col-sm-8 col-sm-offset-2">

            <div class="card-box login-box">
                <div class="text-center">
                    <h4 class="text-uppercase font-bold m-b-0">{{ trans('online_booking.choose_client_title_login') }}</h4>
                </div>
                <div class="panel-body">
                    <form id="choose-user-frm" class="form-horizontal m-t-20 no-overflow">

                        <div v-if="submitted">
                            <input type="hidden" name="name" :value="submitted.name" />
                            <input type="hidden" name="email" :value="submitted.email" />
                            <input type="hidden" name="phone" :value="submitted.phone" />
                            <input type="hidden" name="notes" :value="submitted.notes" />
                            <input type="hidden" name="address" :value="submitted.address" />
                            <input type="hidden" name="city" :value="submitted.city" />
                            <input type="hidden" name="zip" :value="submitted.zip" />
                        </div>

                        <input type="hidden" name="phone_email" :value="phone_email" />
                        <input type="hidden" name="pin" :value="pin" v-if="pin" />

                        <div class="row">
                            <div class="col-xs-12">
                                <ep-banner class="mb-6" v-if="chooseFromLogin">
                                    <i class="zmdi zmdi-info-outline m-r-10 alert-ico"></i>
                                    <span>
                                        {{ trans('online_booking.choose_client_login_description_1') }}
                                        <br>
                                        <strong class="alert-indent">{{ trans('online_booking.choose_client_login_description_2') }}</strong>
                                    </span>
                                </ep-banner>
                                <ep-banner class="mb-6" v-if="!chooseFromLogin">
                                    <i class="zmdi zmdi-info-outline m-r-10 alert-ico"></i>
                                    <span>{{ trans('online_booking.create_client_2') }}</span><br>
                                    <strong class="alert-indent">{{ trans('online_booking.create_client_3') }}</strong>
                                </ep-banner>
                            </div>
                        </div>

                        <div class="row" v-if="!loading">
                            <div class="col-sm-6 col-md-12 col-lg-6 m-b-15" v-for="client in clients">
                                <a class="btn btn-default btn-block" style="overflow:hidden;" @click="clientClicked(client)" if="!loading">
                                    <i class="zmdi zmdi-account m-r-10 alert-ico"></i>{{ client.name }}
                                </a>
                            </div>
                            <div class="col-sm-6 col-md-12 col-lg-6 m-b-15">
                                <a class="btn btn-primary btn-block" @click="clientClicked('new')" v-if="!chooseFromLogin">
                                    <i class="zmdi zmdi-account-add m-r-10 alert-ico"></i>
                                    {{ trans('online_booking.create_client_cta') }}
                                </a>
                            </div>
                            <div v-if="chooseFromLogin && settingsLogin && settingsLogin.allow_create == 1">
                                <div class="col-xs-12"><hr></div>
                                <div class="col-xs-12 choose-user-bottom">
                                    <a class="btn btn-default m-r-10" @click="goBackToChoose()">
                                        <i class="zmdi zmdi-chevron-left m-r-10 alert-ico"></i>
                                        {{ trans('global.back') }}
                                    </a>
                                    <small v-if="settingsLogin && settingsLogin.allow_create">{{ trans('online_booking.choose_client_login_create_description') }}</small>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="loading">
                            <div class="col-xs-12 m-b-15 text-center">
                                <div class="btn-user-loading">
                                    <div class="preloader"></div>
                                </div>
                            </div>
                        </div>

                    </form>

                </div>

            </div>

        </div>
    </div>

</template>
